import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Dashboard from '@/views/dashboard'
import { get, post } from '@/utils/ajax'
import app from '@/main'
import { mapMenus } from '@/utils/utils'
import EnterSchool from './modules/enterSchool' // 进校业务
import Contest from './modules/contest' // 赛事业务

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  linkExactActiveClass: 'active',
  linkActiveClass: 'link-active',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'index',
      redirect: '/dashboard',
      meta: {
        layout: 'dashboard'
      }
    },
    // 个人信息完善页面
    {
      path: '/completeMsg',
      name: 'completeMsg',
      component: () =>
        import('@/views/completeMsg' /* webpackChunkName: "studentManage" */),
      meta: {
        needLogin: true
      }
    },
    // dashboard
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        hideNav: true,
        layout: 'dashboard',
        needLogin: true
      }
    },
    // 班级管理
    {
      path: '/classManage',
      name: 'classManage',
      component: () =>
        import('@/views/classManage' /* webpackChunkName: "classManage" */),
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    // 学生管理
    {
      path: '/studentManage',
      name: 'studentManage',
      component: () =>
        import('@/views/studentManage' /* webpackChunkName: "studentManage" */),
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    // 作品管理
    {
      path: '/workManage',
      name: 'workManage',
      component: () =>
        import('@/views/workManage' /* webpackChunkName: "workManage" */),
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    // 课程管理
    {
      path: '/courseManage',
      name: 'courseManage',
      component: () =>
        import('@/views/courseManage' /* webpackChunkName: "courseManage" */),
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    // 课程教学
    {
      path: '/courseTeaching',
      name: 'courseTeaching',
      component: () =>
        import('@/views/courseTeaching' /* webpackChunkName: "courseTeaching" */),
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    {
      path: '/courseTeaching/studentWork/:id',
      name: 'studentWork',
      component: () => import('@/views/courseTeaching/studentWork' /* webpackChunkName: "studentWork" */),
      meta: {
        layout: 'noop',
        needLogin: true
      }
    },
    // h5全屏播放
    {
      path: '/h5player',
      component: () =>
        import('@/views/courseManage/courseDetail/h5player' /* webpackChunkName: "h5player" */),
      name: 'h5player'
    },
    // 课程包列表
    {
      path: '/courseManage/list/:courseType?/:id',
      name: 'courseList',
      component: () =>
        import(
          '@/views/courseManage/courseList' /* webpackChunkName: "courseList" */
        ),
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    // 成长档案
    {
      path: '/courseManage/growthFile',
      name: 'growthFile',
      component: () =>
        import(
          '@/views/courseManage/growthFile' /* webpackChunkName: "growthFile" */
        ),
      meta: {
        layout: 'dashboard',
        needLogin: true,
        clearPadding: true
      }
    },
    // 查看成长档案
    {
      path: '/courseManage/viewGrowthFile',
      name: 'viewGrowthFile',
      component: () =>
        import(
          '@/views/courseManage/viewGrowthFile' /* webpackChunkName: "viewGrowthFile" */
        ),
      meta: {
        layout: 'dashboard',
        needLogin: true,
        clearPadding: true
      }
    },
    // 新增成长档案
    {
      path: '/courseManage/addGrowthFile',
      name: 'addGrowthFile',
      component: () =>
        import(
          '@/views/courseManage/addGrowthFile' /* webpackChunkName: "addGrowthFile" */
        ),
      meta: {
        layout: 'dashboard',
        needLogin: true,
        clearPadding: true
      }
    },
    // 编辑成长档案
    {
      path: '/courseManage/editGrowthFile',
      name: 'editGrowthFile',
      component: () =>
        import(
          '@/views/courseManage/editGrowthFile' /* webpackChunkName: "editGrowthFile" */
        ),
      meta: {
        layout: 'dashboard',
        needLogin: true,
        clearPadding: true
      }
    },
    // 备课课程详情
    {
      path: '/courseManage/checkPrepareDetail/:id',
      name: 'checkPrepareDetail',
      component: () =>
        import(
          '@/views/courseManage/courseDetail' /* webpackChunkName: "checkPrepareDetail" */
        ),
      meta: {
        layout: 'prepareDetail'
      }
    },
    // 课程详情
    {
      path: '/courseManage/detail/:type/:id/:action?',
      name: 'courseDetail',
      component: () =>
        import(
          '@/views/courseManage/courseDetail' /* webpackChunkName: "courseDetail" */
        ),
      meta: {
        layout: 'noop',
        needLogin: true
      }
    },
    // 备课
    {
      path: '/courseManage/prepare/:packageId/:lessonId',
      name: 'prepareCourse',
      component: () =>
        import(
          '@/views/courseManage/prepareCourse' /* webpackChunkName: "prepareCourse" */
        ),
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    // 课程中心 > 课程记录 （这期暂时不做）
    // {
    //   path: '/courseManage/record',
    //   name: 'courseRecord',
    //   component: () =>
    //     import(
    //       '@/views/courseManage/courseRecord' /* webpackChunkName: "courseRecord" */
    //     ),
    //   meta: {
    //     layout: 'dashboard',
    //     needLogin: true
    //   }
    // },
    // 教师管理
    {
      path: '/teacherManage',
      name: 'teacherManage',
      component: () =>
        import('@/views/teacherManage' /* webpackChunkName: "teacherManage" */),
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    // 单位管理
    {
      path: '/unitManage',
      name: 'unitManage',
      component: () =>
        import('@/views/unitManage' /* webpackChunkName: "unitManage" */),
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    {
      path: '/myWork',
      name: 'myWork',
      component: () =>
        import('@/views/myWork' /* webpackChunkName: "myWork" */),
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    // help
    {
      path: '/help',
      component: () => import('@/views/help' /* webpackChunkName: "help" */),
      name: 'help',
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    // tool
    {
      path: '/tool',
      component: () => import('@/views/tool' /* webpackChunkName: "tool" */),
      name: 'tool',
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    // learning Statistics
    {
      path: '/learningStatistics',
      component: () =>
        import(
          '@/views/learningStatistics' /* webpackChunkName: "learningStatistics" */
        ),
      name: 'learningStatistics',
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    // 学情报告-学生成长档案列表
    {
      path: '/learningGrowthFile/:account_id/:real_name',
      component: () =>
        import(
          '@/views/learningStatistics/growthFile/lessonsList' /* webpackChunkName: "learningGrowthFile" */
        ),
      name: 'learningGrowthFile',
      meta: {
        layout: 'dashboard',
        needLogin: true,
        clearPadding: true
      }
    },
    // 学情报告-查看成长档案
    {
      path: '/learningviewGrowthFile',
      name: 'learningviewGrowthFile',
      component: () =>
        import(
          '@/views/learningStatistics/viewGrowthFile' /* webpackChunkName: "learningviewGrowthFile" */
        ),
      meta: {
        layout: 'dashboard',
        needLogin: true,
        clearPadding: true
      }
    },
    // 学情报告-编辑成长档案
    {
      path: '/learningEditGrowthFile',
      name: 'learningEditGrowthFile',
      component: () =>
        import(
          '@/views/learningStatistics/editGrowthFile' /* webpackChunkName: "learningEditGrowthFile" */
        ),
      meta: {
        layout: 'dashboard',
        needLogin: true,
        clearPadding: true
      }
    },
    // mark work
    {
      path: '/:type/markWork',
      component: () =>
        import('@/views/markWork' /* webpackChunkName: "markWork" */),
      name: 'markWork',
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    {
      path: '/data_graph',
      component: () =>
        import('@/views/data_graph' /* webpackChunkName: "data_graph" */),
      name: 'dataGraph',
      meta: {
        needLogin: true
      }
    },
    {
      path: '/data_graph_table',
      component: () =>
        import('@/views/data_graph/table' /* webpackChunkName: "dataGraphTable" */),
      name: 'dataGraphTable',
      meta: {
        needLogin: true
      }
    },
    {
      path: '/viewer',
      component: () =>
        import('@/views/viewer' /* webpackChunkName: "viewer" */),
      name: 'viewer'
    },
    {
      path: '/jumper',
      component: () =>
        import('@/views/jumper' /* webpackChunkName: "jumper" */),
      name: 'jumper'
    },
    // 站内信
    {
      path: '/mail',
      component: () => import('@/views/mail' /* webpackChunkName: "jumper" */),
      name: 'mail',
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    // ai双师
    {
      path: '/mlzTeacher',
      name: 'mlzTeacher',
      component: () =>
        import('@/views/mlzTeacher' /* webpackChunkName: "mlzTeacher" */),
      meta: {
        layout: 'dashboard',
        needLogin: true,
        mlz: true
      }
    },
    // ai双师课程手册
    {
      path: '/mlzCourseManual',
      name: 'mlzCourseManual',
      component: () =>
        import(
          '@/views/mlzCourseManual' /* webpackChunkName: "mlzCourseManual" */
        ),
      meta: {
        layout: 'dashboard',
        needLogin: true,
        mlz: true
      }
    },
    // ai双师班级评价列表
    {
      path: '/mlzClassEvaList',
      name: 'mlzClassEvaList',
      component: () =>
        import(
          '@/views/mlzClassEvaList' /* webpackChunkName: "mlzClassEvaList" */
        ),
      meta: {
        layout: 'dashboard',
        needLogin: true,
        mlz: true
      }
    },
    // ai双师班级评价详情
    {
      path: '/mlzClassEvaDetail',
      component: () =>
        import(
          '@/views/mlzClassEvaDetail' /* webpackChunkName: "mlzClassEvaDetail" */
        ),
      name: 'mlzClassEvaDetail',
      meta: {
        layout: 'dashboard',
        needLogin: true,
        mlz: true
      }
    },
    // ai双师学生评价列表
    {
      path: '/mlzStudentEvaList',
      name: 'mlzStudentEvaList',
      component: () =>
        import(
          '@/views/mlzStudentEvaList' /* webpackChunkName: "mlzStudentEvaList" */
        ),
      meta: {
        layout: 'dashboard',
        needLogin: true,
        mlz: true
      }
    },
    // ai双师学生评价详情
    {
      path: '/mlzStudentEvaDetail',
      component: () =>
        import(
          '@/views/mlzStudentEvaDetail' /* webpackChunkName: "mlzStudentEvaDetail" */
        ),
      name: 'mlzStudentEvaDetail',
      meta: {
        layout: 'dashboard',
        needLogin: true,
        mlz: true
      }
    },
    // B2C
    {
      path: '/B2C',
      component: () => import('@/views/B2C' /* webpackChunkName: "B2C" */),
      name: 'B2C',
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    // 学校申请
    {
      path: '/schoolApply',
      component: () => import('@/views/schoolApply' /* webpackChunkName: "schoolApply" */),
      name: 'schoolApply',
      meta: {
        layout: 'dashboard',
        needLogin: true
      }
    },
    // 定制教室的教师、学生注册
    {
      path: '/redcandle',
      component: () => import('@/views/customization/register' /* webpackChunkName: "redcandle" */),
      name: 'redcandle'
    },
    ...EnterSchool,
    ...Contest
  ]
})

/**
 * 相关逻辑强关联性优先判断从学院来的跳转清除之前的定制教室信息 请勿移动判断顺序
 * fromSchool => 始终对应codemao数据大屏
 * 然后进行 是否定制教室的登录页面检测
 */
router.beforeEach(async (to, from, next) => {
  // 从学院来的跳转清除之前的定制教室信息
  if (to.query.fromSchool) {
    store.commit('SET_CUSTOM_INFO', null)
    localStorage.removeItem('customInfo')
    return next({ ...to, query: { ...to.query, fromSchool: void 0 } })
  }
  // 没有匹配的路由情况下跳这里，这里登录后回到index页面，已是定制化内容
  if (!to.matched.length) {
    // 本地调试科协(全局搜索本段文字，还需修改一个位置)
    // const url = 'https://dev-teacher.edu.codemao.cn/xxpt'
    const url =
      window.location.href.indexOf('?') !== -1
        ? window.location.href.split('?')[0]
        : window.location.href
    const data = await post('/edu/zone/district/classroom/url', {
      url: url.replace('http://localhost:8080', 'https://test-teacher-edu.codemao.cn')
    })
    if (data) {
      const customInfo = {
        isCustom: true,
        url,
        fromScience: to.fullPath === '/xxpt',
        ...data
      }
      localStorage.setItem('customInfo', JSON.stringify(customInfo))
      store.commit('SET_CUSTOM_INFO', customInfo)
      // 1.判断是否为智慧校园定制版点猫编程平台
      // 2.调用授权接口
      let useComponent
      if (
        to.path === '/sichuan' &&
        to.query.uid &&
        to.query.token &&
        to.query.timestamp
      ) {
        const winshareData = {
          token: to.query.token,
          uid: to.query.uid,
          timestamp: to.query.timestamp,
          pid: 'PxtCITc9',
          client_id: 'WEB'
        }

        try {
          await app.$auth('logout')
        } catch (error) {
          /* eslint-disable-next-line */
          console.log(error)
        }

        try {
          const winshareRes = await post(
            `${window.CONFIG.tiger}/tiger/v3/web/accounts/oauth/winshare`,
            winshareData,
            { noToken: true, credential: true, ignoreMsg: true, 'auth_version': '1.0.0' }
          )
          if (!winshareRes.existed) {
            useComponent = () =>
              import('@/views/winShare' /* webpackChunkName: "winShare" */)
            store.commit('SET_WIN_SHARE_INFO', winshareRes)
          } else if (winshareRes.auth && winshareRes.auth.token) {
            await app.$sdk.token.set(winshareRes.auth.token)
          }
        } catch (error) {
          if (error.error_code === 'AC3_28') {
            const url = encodeURIComponent(`${window.CONFIG.teacher}/sichuan`)
            window.open(
              `${window.CONFIG.win_share}/winshare-web-portal/pages/3rdlogin.jsp?appid=68c94f4affa97e4974d8e927183a91a1&callback=${url}`,
              '_self'
            )
          }
          if (error.error_code === 'AC3_29') {
            app.$message.error('对不起，您没有进入点猫编程平台的权限')
          }
        }
      }

      // 判断是否为人工智能定制版点猫编程平台
      if (to.path === '/rgzn' && to.query.code) {
        const aiData = {
          code: to.query.code,
          pid: 'PxtCITc9',
          client_id: 'WEB',
          redirect_uri: `${CONFIG.teacher}/rgzn`
        }

        try {
          await app.$auth('logout')
        } catch (error) {
          /* eslint-disable-next-line */
          console.log(error)
        }

        try {
          // 调用平台授权接口
          const aiRes = await post(
            `${window.CONFIG.tiger}/tiger/v3/web/accounts/oauth/icollege`,
            aiData,
            { noToken: true, credential: true, ignoreMsg: true, 'auth_version': '1.0.0' }
          )
          // 已有账号
          await window.iris.auth.get_auth_instance().token.set(aiRes.auth.token)
          // 新建作品(已登录，且地址栏地址不带作品id，直接跳转到ide)
          // 继续创作(已登录，带作品id，传参数跳转到ide)
          if (to.query.code && !to.query.state) {
            window.open(window.CONFIG.ide, '_self')
          } else if (to.query.code && to.query.state) {
            window.open(`${window.CONFIG.ide}/#${to.query.state}`, '_self')
          }
        } catch (error) {
          switch (error.error_code) {
            case 'AC3_24':
              app.$message.error('不合法的pid')
              break
            case 'AC3_35':
              app.$message.error('icollege 异常')
              break
          }
        }
      }

      // 对接南昌第三方平台实现直接跳转点猫编程平台（后台没有添加对应的定制教室）
      if (to.path === '/nc' && to.query.code && to.query.state && to.query.session_state) {
        const dledcData = {
          code: to.query.code,
          // redirect_uri: `${CONFIG.teacher}/nc`,
          // redirect_uri: `https://teacher.edu.codemao.cn/nc`, // 调试南昌dev
          redirect_uri: `https://teacher-edu.codemao.cn/nc`, // 调试南昌dev
          pid: 'PxtCITc9',
          client_id: 'WEB'
        }

        try {
          await app.$auth('logout')
        } catch (error) {
          /* eslint-disable-next-line */
          console.log(error)
        }

        try {
          const dledcRes = await post(
            `${window.CONFIG.tiger}/tiger/v3/web/accounts/oauth/dledc`,
            dledcData,
            { noToken: true, credential: true, ignoreMsg: true, 'auth_version': '1.0.0' }
          )
          if (dledcRes.auth && dledcRes.auth.token) {
            await Vue.prototype.$sdk.iris.auth.get_auth_instance().token.set(dledcRes.auth.token)
            return next({ name: 'index' })
          }
        } catch (error) {
          switch (error.error_code) {
            case 'AC3_24':
              app.$message.error('不合法的pid')
              break
            case 'AC3_36':
              app.$message.error('南昌市开发平台异常')
              break
            case 'AC3_37':
              app.$message.error('拒绝该类型的南昌开放平台账号')
              break
          }
        }
      }
      const route = [
        {
          path: to.fullPath,
          component:
            useComponent ||
            (() =>
              import(
                '@/views/customization' /* webpackChunkName: "customization" */
              )),
          name: 'customizationClass'
        }
      ]
      router.addRoutes(route)
      return next({ name: 'index' })
    } else {
      return next({ name: 'jumper' })
    }
  }

  // 对接南昌第三方平台实现直接跳转点猫编程平台(未使用定制教室)
  // if (to.path === '/nc' && to.query.code && to.query.state && to.query.session_state) {
  //   localStorage.getItem('customInfo') && localStorage.removeItem('customInfo')
  //   let useComponent
  //   const dledcData = {
  //     code: to.query.code,
  //     redirect_uri: `${CONFIG.teacher}/nc`,
  //     // redirect_uri: `https://dev-teacher.edu.codemao.cn/nc`, // 调试南昌dev
  //     pid: 'PxtCITc9',
  //     client_id: 'WEB'
  //   }

  //   try {
  //     const dledcRes = await post(
  //       `${window.CONFIG.tiger}/tiger/v3/web/accounts/oauth/dledc`,
  //       dledcData,
  //       { noToken: true, credential: true, ignoreMsg: true, 'auth_version': '1.0.0' }
  //     )
  //     if (!dledcRes.existed) {
  //       useComponent = () =>
  //         import('@/views/dledc' /* webpackChunkName: "dledc" */)
  //       store.commit('SET_DLEDC_INFO', dledcRes)
  //     } else
  //     if (dledcRes.auth && dledcRes.auth.token) {
  //       await Vue.prototype.$sdk.iris.auth.get_auth_instance().token.set(dledcRes.auth.token)
  //       return next({ name: 'index' })
  //     }
  //   } catch (error) {
  //     switch (error.error_code) {
  //       case 'AC3_24':
  //         app.$message.error('不合法的pid')
  //         break
  //       case 'AC3_36':
  //         app.$message.error('南昌市开发平台异常')
  //         break
  //       case 'AC3_37':
  //         app.$message.error('拒绝该类型的南昌开放平台账号')
  //         break
  //     }
  //   }
  //   const route = [
  //     {
  //       path: to.fullPath,
  //       component: useComponent,
  //       name: 'customizationClass'
  //     }
  //   ]
  //   router.addRoutes(route)
  //   return next({ name: 'customizationClass' })
  // }
  next()
})

// 登录态判断
router.beforeEach(async (to, from, next) => {
  if (to.meta.needLogin && !store.state.hasToken) {
    try {
      await Vue.prototype.$auth('get_access_token')
      store.commit('HAS_TOKEN', true)
    } catch (error) {
      const nextStep =
        store.state.customInfo && store.state.customInfo.isCustom
          ? 'customizationClass'
          : 'jumper'
      return next({ name: nextStep })
    }
  }
  next()
})

// 是否有教室权限判断及获取B端基础信息并跳转对应的端
router.beforeEach(async (to, from, next) => {
  if (to.meta.needLogin && !store.state.isOpen) {
    const { third_info, ...rest } = await get('/api/home/account')
    if (!rest.is_open) {
      const nextStep =
        store.state.customInfo && store.state.customInfo.isCustom
          ? 'customizationClass'
          : 'jumper'
      next({ name: nextStep })
      if (nextStep === 'jumper') {
        return Vue.prototype.$message.error('该用户还未开通点猫编程平台')
      } else return
    }
    store.commit('IS_OPEN', true)
    store.commit('SET_USER', {
      ...rest,
      third_info,
      thirdOutUrl: third_info && third_info.third_out_url, // 第三方登录退出跳回地址
      isThirdUserType1: third_info && third_info.third_type === '1' // 西安工业云第三方登录
    })
    // 数据大屏用户
    if (rest.role_id === 40002) {
      if (to.name === 'dashboard') {
        next({ name: 'dataGraph' })
      }
    } else {
      store.dispatch('getUnreadMessage')
      next()
    }
  }
  next()
})

// 标记用户是否弱密码
router.beforeEach(async (to, from, next) => {
  if (to.query.weakPassword) {
    store.commit('IS_WEAK_PASSWORD', true)
    return next({ ...to, query: { ...to.query, weakPassword: void 0 } })
  }
  next()
})

// 语法糖
router.beforeEach((to, from, next) => {
  Vue.prototype.routerView = to.name
  next()
})

// 定制教室(实现登录状态时：路由为/或dashboard时匹配最新菜单)
router.beforeEach((to, from, next) => {
  if (
    to.name === 'dashboard' &&
    store.state.customInfo &&
    !store.state.isFirst
  ) {
    const menus = JSON.parse(localStorage.getItem('menus'))
    if (menus && menus.length) {
      const data = mapMenus(store.state.dashboard.menuRouter, menus[0])
      if (data) {
        store.commit('IS_FIRST', true)
        return next({ name: data })
      }
    }
  } else {
    next()
  }
  next()
})

export default router
